import { Component, OnInit } from '@angular/core';
import { SurveyQuestionnaireService } from '../survey-questionnaire.service';
import { Observable } from 'rxjs';
import { Survey, SurveyStatus } from '../models/survey.model';
import { ActivatedRoute, Router } from '@angular/router';
import { BrightsideUiModule } from '@brightside/brightside-ui';
import { MicroUiMoleculeModule } from '@micro-ui/molecule';
import { SharedDesktopModule } from '@brightside-web/shared/desktop';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe, CommonModule, NgIf } from '@angular/common';

@Component({
    selector: 'brightside-web-survey-intro',
    templateUrl: './survey-intro.component.html',
    styleUrls: ['./survey-intro.component.scss'],
    imports: [
        CommonModule,
        BrightsideUiModule,
        MicroUiMoleculeModule,
        SharedDesktopModule,
        TranslateModule
    ],
    providers: []
})
export class SurveyIntroComponent implements OnInit {
  surveyData$: Observable<Survey | undefined>;
  SurveyStatus = SurveyStatus;

  constructor(
    private _surveyQuetionnaireService: SurveyQuestionnaireService,
    private _router: Router,
    private _route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.surveyData$ = this._surveyQuetionnaireService.surveyData$;
  }

  backToHomePage(): void {
    this._surveyQuetionnaireService.backToHomeCalled()
  }

  startWithSurveyQuestions(): void {
    this._router.navigate(['../view'], { relativeTo: this._route });
  }
}
